module.exports = __webpack_public_path__ + "img/ChillenAnDerBib.ed2494e5.jpg";